/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from "react";
import Highcharts from "highcharts";

function PieChart({ paymentTypeData }) {
  const chartRef = useRef(null);
  // // const paymentData = [
  // //   // { name: 'Netbanking', y: 40 },
  // //   // { name: 'UPI', y: 30 },
  // //   // { name: 'Credit Card', y: 30 },
  // //   // {name: 'Debit Card', y: 40}
  // // {name: 'Card', y: 30},
  // // {name: "MANDATE", y:11},
  // // {name: "NET BANKING", y: 16},
  // // {name: "WALLET", y: 20},
  // // {name: "UPI", y:23}
  // // ];

  // // const total = paymentData.reduce((sum, item) => sum + item.y, 0);
  // const total = paymentTypeData.reduce((sum, item) => sum + item.y, 0);

  // // const formattedData = paymentData.map(item => ({
  // //   name: item.name,
  // //   y: (item.y / total) * 100,
  // // }));

  // const formattedData = paymentTypeData.map((item) => ({
  //   name: item.name,
  //   y: (item.y / total) * 100,
  // }));
  // const paymentData = [
  //   { name: "Card", y: 30 },
  //   { name: "MANDATE", y: 11 },
  //   { name: "NET BANKING", y: 16 },
  //   { name: "WALLET", y: 20 },
  //   { name: "UPI", y: 23 },
  // ];

  let formattedData;
  let total;

  if (paymentTypeData && paymentTypeData.length > 0) {
    total = paymentTypeData.reduce((sum, item) => sum + item.y, 0);
    formattedData = paymentTypeData.map((item) => ({
      name: item.name,
      y: (item.y / total) * 100,
      // z: Math.random(),
      z: item.receiptCount,
    }));
  }
  // else {
  //   total = paymentData.reduce((sum, item) => sum + item.y, 0);
  //   formattedData = paymentData.map((item) => ({
  //     name: item.name,
  //     y: (item.y / total) * 100,
  //   }));
  // }
  // const filteredData = formattedData.filter((item) => item.y > 0);
  useEffect(() => {
    if (chartRef.current) {
      Highcharts.chart(chartRef.current, {
        chart: {
          type: "pie",
          minWidth: 240,
        },
        // title: {
        //   text: 'Payment Type',
        //   align: 'left',
        //   style: {
        //     color: '#585858',
        //   },
        // },
        title: {
          text: null,
        },
        tooltip: {
          formatter() {
            return `${this.point.name}: <b>${this.point.y.toFixed(
              0,
            )}%</b><br>Number of Receipts: <b>${this.point.z.toLocaleString(
              "en-IN",
            )}</b>`;
          },
        },
        plotOptions: {
          pie: {
            dataLabels: {
              connectorWidth: 0, // Disable connector lines
              enabled: true,
              // format: '{point.percentage:.2f}%<br><b>{point.name}</b>',
              formatter() {
                if (this.point.percentage > 15) {
                  return `${this.point.percentage.toFixed(0)}%<br><b>${
                    this.point.name
                  }</b>`;
                }
                return null;
              },
              style: {
                textOverflow: "ellipsis",
                whiteSpace: "wrap",
                color: "white",
                fontSize: "12px",
                fontWeight: "500",
              },
              distance: -50,
            },
          },
        },
        series: [
          {
            name: "Payment Method",
            colorByPoint: true,
            data: formattedData,
            borderWidth: 1,
          },
        ],
        colors: [
          {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "#F35327"],
              [1, "#FC9929"],
            ],
          }, // Gradient for Card
          {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "#1853EA"],
              [1, "#6B94FF"],
            ],
          }, // Gradient for NetBanking
          {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "#1E8DA1"],
              [1, "#2FCAC5"],
            ],
          }, // Gradient for Wallet
          {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "#E5B32C"],
              [1, "#FFCF4D"],
            ],
          }, // Gradient for Upi
          {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "#FF81EB"],
              [1, "#C907AB"],
            ],
          }, // Gradient for Cheques
          {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "#A08FF4"],
              [1, "#5B45B2"],
            ],
          }, // Gradient for Cash
        ],
      });
    }
  }, [paymentTypeData]);

  return <div ref={chartRef} style={{ minWidth: "240px" }} />;
}

export default PieChart;
